"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Location_styles_1 = require("../Location.styles");
const LocationLink = (_a) => {
    var { location, children, getLocationUrl, locationCallback } = _a, props = __rest(_a, ["location", "children", "getLocationUrl", "locationCallback"]);
    const locationUrl = location.location_page_override_url || getLocationUrl(location);
    const locationId = location.primary_marketable_location_id || location.id;
    const isExternalUrl = Boolean(location.location_page_override_url);
    const handleClick = (e) => {
        e.preventDefault();
        if (locationCallback && locationUrl) {
            locationCallback(locationUrl, isExternalUrl);
        }
    };
    return (react_1.default.createElement(Location_styles_1.LocationLinkContainer, null,
        react_1.default.createElement(Location_styles_1.LocationName, Object.assign({}, props), locationUrl ? (react_1.default.createElement(Location_styles_1.LocationAnchor, { "data-testid": `locationLink-${locationId}`, href: locationUrl, onClick: handleClick, target: isExternalUrl ? '_blank' : undefined, rel: isExternalUrl ? 'noopener' : undefined }, children)) : (children))));
};
exports.default = LocationLink;
//# sourceMappingURL=LocationLink.js.map